import { Download } from "@mui/icons-material"
import { ReceiptAction, SuccessCircleIcon, StyledCloseIcon } from "../../styles"
import { ButtonDownload, InactivateContainer, ReceiptDetailContainer, ReceiptDetailFooter } from "./styles"
import { imageStatus } from "../../.."
import { USER_TYPES } from "../../../../../../../Admin/shared/static-options"

export const SelectedReceiptIdentifier = ({
  alt,
  data,
  status,
  imageName,
  openReceiptModal,
  downloadImage,
  userType,
}) => {
  return (
    <div>
      <div>
        <ReceiptDetailContainer>
          <img src={data.link} alt={alt} width='100%' />
        </ReceiptDetailContainer>
      </div>
      <ReceiptDetailFooter>
        {userType === USER_TYPES.CUSTOMER_SERVICE_USER && (
          status === imageStatus.ACTIVE ? (
            <InactivateContainer>
              <StyledCloseIcon />
              <ReceiptAction
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => openReceiptModal(data, status)}
              >
                Inativar
              </ReceiptAction>
            </InactivateContainer>
            ) : (
              <InactivateContainer>
                <SuccessCircleIcon />
                <ReceiptAction
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => openReceiptModal(data, status)}
                >
                  Reativar
                </ReceiptAction>
              </InactivateContainer>    
            )
          )
        }
        <ButtonDownload onClick={() => downloadImage(data.link, imageName)}>
          <Download />
          Baixar imagem
        </ButtonDownload>
      </ReceiptDetailFooter>
    </div>
  )
}
